import type { SVGProps } from 'react';

export function DeviceYubikeyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.198 3.724a1.08 1.08 0 0 1 1.526 0l3.052 3.052a1.08 1.08 0 0 1 0 1.527l-3.052 3.052-4.58-4.579zM16.96 12.119c.844.842.844 2.21 0 3.052l-6.868 6.868a2.16 2.16 0 0 1-3.052 0L2.46 17.46a2.16 2.16 0 0 1 0-3.052L9.33 7.54a2.16 2.16 0 0 1 3.052 0zm-4.578 0a2.698 2.698 0 1 0-3.816 3.815 2.698 2.698 0 0 0 3.816-3.815" />
    </svg>
  );
}
